import { iframeResizer } from 'iframe-resizer';

document.addEventListener('DOMContentLoaded', () => {
    iframeResizer({ log: true, checkOrigin: false }, '.dynamic-iframe-el');
});
